const EditorialGrid = `
  :root {
    --nts-grid-gutter: 12px;
    --nts-grid-inner-padding: 8px;
    --nts-grid-inner-padding-s: 4px;
  }

  .editorial-grid-container {
    padding: 16px var(--nts-grid-gutter);
  }

  .editorial-grid {
    display: flex;
    flex-wrap: wrap;
    margin-left: calc(var(--nts-grid-gutter) * -1);
    margin-right: calc(var(--nts-grid-gutter) * -1);
  }

  .editorial-grid__item {
    box-sizing: border-box;
    padding: var(--nts-grid-gutter);
    width: 100%;
  }

  .editorial-grid__item-content {
    border: 2px solid var(--nts-white);
    box-sizing: border-box;
    position: relative;
    overflow: hidden;
    padding: var(--nts-grid-inner-padding-s);
    padding-bottom: 80px;
  }

  .editorial-grid__picture {
    display: block;
    height: 0;
    overflow: hidden;
    padding-bottom: 56.25%;
    position: relative;
  }

  .editorial-grid__picture-img {
    object-fit: cover;
    position: absolute;
    top: 50%;
    height: 100%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
  }

  .editorial-grid__picture-overlay {
    align-items: flex-end;
    bottom: 0;
    cursor: pointer;
    display: flex;
    left: 0;
    outline: 0;
    padding: 0;
    position: absolute;
    right: 0;
    top: 0;
    width: 100%;
  }

  .editorial-grid__item-header {
    color: var(--nts-white);
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-top: 4px;
    padding: var(--nts-grid-inner-padding);
    transition: color 0.1s linear, background-color 0.1s linear;
    text-decoration: none;
  }

  .editorial-grid__item-header:hover,
  .editorial-grid__item-header:focus {
    background-color: var(--nts-white);
    color: var(--nts-black);
  }

  .editorial-grid__item-header-title {
    flex-basis: 100%;
    margin-top: 4px;
    font-size: 22px;
    line-height: 24px;
  }

  @media(min-width: 768px) {
    .editorial-grid__item {
      min-width: 50%;
      width: 50%;
    }

    .editorial-grid__item-content {
      height: 100%;
      padding: var(--nts-grid-inner-padding);
      padding-bottom: 80px;
    }
  }

  @media(min-width: 1025px) {
    .editorial-grid__item {
      min-width: calc(100% / 3);
      width: calc(100% / 3);
    }

    .editorial-grid__item-header-title {
      font-size: 18px;
      line-height: 20px;
    }

    .editorial-grid__picture-overlay {
      align-items: center;
      justify-content: center;
      transition: background-color 0.1s linear;
    }

    .editorial-grid__picture-overlay:hover,
    .editorial-grid__picture-overlay:focus {
      background-color: rgba(0, 0, 0, 0.8);
    }

    .editorial-grid__picture-overlay:hover .nts-icon,
    .editorial-grid__picture-overlay:focus .nts-icon {
      opacity: 1;
    }

    .editorial-grid__picture-overlay .nts-icon {
      fill: var(--nts-white);
      opacity: 0;
      transition: opacity .1s linear;
    }
  }

  @media(min-width: 1190px) {
    .editorial-grid__item {
      min-width: 25%;
      width: 25%;
    }
  }

  @media(min-width: 1500px) {
    .editorial-grid__item {
      min-width: 20%;
      width: 20%;
    }
  }
`

export default EditorialGrid
